import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../constants";
import { eventTrackPayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface GameQuestQuestionAnsweredPayload extends EventPayload {
  game: {
    playTime: number;
  };
  content: {
    title: string;
  };
  message: {
    title: string;
    body: string;
  };
}

const GameQuestQuestionAnsweredAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.lowPoly,
  eventName: "Game Quest Question Answered",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createGameQuestQuestionAnsweredTrackEventPayload =
  eventTrackPayloadCreator<GameQuestQuestionAnsweredPayload>(
    GameQuestQuestionAnsweredAnalyticsEvent,
  );
